export const dummyEmails = [
  ["Email Address"],
  ["sagarvasu98@gmail.com"],
  ["sagar@thetalentgames.com"],
  ["khurram@thetalentgames.com"],
  ["sagar@thetalentgames.com"],
];
